import { NgModule } from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
  NbSpinnerModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbDatepickerModule,
  NbAlertModule,
  NbDialogModule,
  NbRouteTabsetModule,
  NbLayoutModule,
  NbAccordionModule,
  NbCheckboxModule,
  NbRadioModule,
  NbStepperModule,
  NbToastrModule, NbBadgeModule, NbTooltipModule, NbInputModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartModule } from 'angular2-chartjs';
import { SafeHtmlPipe } from '../../safe-html-pipe.pipe';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { SplasboardComponent } from './splasboard.component';
import { StationsIndicatorsComponent } from '../stations-indicators/stations-indicators.component';
import { LegalRequirementsComponent } from './legal-requirements/legal-requirements.component';
import { CustomRendererComponent } from './legal-requirements/custom-renderer.component';
import { SassisopaComponent } from './sassisopa/sassisopa.component';
import { SgmComponent } from './sgm/sgm.component';
import { LogbooksSectionComponent } from './logbooks-section/logbooks-section.component';
import { IndicatorsComponent } from './indicators/indicators.component';
import { CapacitationComponent } from './capacitation/capacitation.component';
import { AddincientLogbookComponent } from '../add-incident-logbook/add-incident-logbook.component';
import { AddManteinenceLogbookComponent } from '../add-manteinence-logbook/add-manteinence-logbook.component';
import { AddProductLogbookComponent } from '../add-product-logbook/add-product-logbook.component';
import { AddReceptionDownloadLogbookComponent } from '../add-reception-download-logbook/add-reception-download-logbook.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogbooksComponent } from './logbooks/logbooks.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SignaturePadModule } from 'angular2-signaturepad';
import { CalendarComponent } from '../calendar/calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SetDateLegalRequirementComponent } from './set-date-legal-requirement/set-date-legal-requirement.component';
import { EmployeesComponent } from '../../employees/employees.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NewEmployeeComponent } from '../../new-employee/new-employee.component';
import { EditEmployeeComponent } from '../../edit-employee/edit-employee.component';
import { ImplementationSassisopaComponent } from '../../implementation-sassisopa/implementation-sassisopa.component';
import { DocumentsComponent } from '../../implementation-sassisopa/documents/documents.component';
import { DetailComponent as DocumentDetailSasisopa } from '../../implementation-sassisopa/documents/detail/detail.component';
import { EditCreateDeleteComponent as DocumentDetailSasisopaEditCreateDeleteComponent } from './../../implementation-sassisopa/documents/detail/edit-create-delete/edit-create-delete.component';
import { FileManagerComponent as FileManagerComponentSasisopa } from '../../implementation-sassisopa/file-manager/file-manager.component';
import { AddLogbookComponent } from '../../add-logbook/add-logbook.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AddStationComponent} from '../../add-station/add-station.component';
import { ProcedureOneComponent } from '../../procedures/procedure-one/procedure-one.component';
import { ProcedureTwoComponent } from '../../procedures/procedure-two/procedure-two.component';
import { ProcedureThreeComponent } from '../../procedures/procedure-three/procedure-three.component';
import { ProcedureFourComponent } from '../../procedures/procedure-four/procedure-four.component';
import { ProcedureFiveComponent } from '../../procedures/procedure-five/procedure-five.component';
import { ProcedureSixComponent } from '../../procedures/procedure-six/procedure-six.component';
import { ProcedureSevenComponent } from '../../procedures/procedure-seven/procedure-seven.component';
import { ProcedureEigthComponent } from '../../procedures/procedure-eigth/procedure-eigth.component';
import { ProcedureNineComponent } from '../../procedures/procedure-nine/procedure-nine.component';
import { ProcedureTenComponent } from '../../procedures/procedure-ten/procedure-ten.component';
import { ProcedureElevenComponent } from '../../procedures/procedure-eleven/procedure-eleven.component';
import { ProcedureTwelveComponent } from '../../procedures/procedure-twelve/procedure-twelve.component';
import { ProcedureThirteenComponent } from '../../procedures/procedure-thirteen/procedure-thirteen.component';
import { ProcedureFourteenComponent } from '../../procedures/procedure-fourteen/procedure-fourteen.component';
import { ProcedureFiveteenComponent } from '../../procedures/procedure-fiveteen/procedure-fiveteen.component';
import { ProcedureSixteenComponent } from '../../procedures/procedure-sixteen/procedure-sixteen.component';
import { ProcedureSeventeenComponent } from '../../procedures/procedure-seventeen/procedure-seventeen.component';
import { ProcedureEigthteenComponent } from '../../procedures/procedure-eigthteen/procedure-eigthteen.component';
import { UsersComponent } from '../../users/users.component';
import { NewUserComponent } from '../../new-user/new-user.component';
import { EditUserComponent } from '../../edit-user/edit-user.component';
import { MeetingsComponent } from '../../meetings/meetings.component';
import { AddMeetingComponent } from '../../add-meeting/add-meeting.component';
import { EditMeetingComponent } from '../../edit-meeting/edit-meeting.component';
import { MachinesComponent } from '../../machines/machines.component';
import { NewMachineComponent } from '../../new-machine/new-machine.component';
import { EditMachineComponent } from '../../edit-machine/edit-machine.component';
import { SysUsersComponent } from '../../sys-users/sys-users.component';
import { EditSysUsersComponent } from '../../edit-sys-users/edit-sys-users.component';
import { NewSysUsersComponent } from '../../new-sys-users/new-sys-users.component';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { CompleteRegisterComponent } from './complete-register/complete-register.component';
import { EditStationComponent } from './stations/edit-station/edit-station.component';
import { DetailStationComponent } from './stations/detail-station/detail-station.component';
import { ProfileComponent } from '../../profile/profile.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EditLogbookComponent } from './logbooks/edit/edit-logbook.component';
import { EditIncientLogbookComponent } from './logbooks/edit/edit-incident-logbook/edit-incident-logbook.component';
import { EditManteinenceLogbookComponent } from './logbooks/edit/edit-manteinence-logbook/edit-manteinence-logbook.component';
import { EditReceptionDownloadLogbookComponent } from './logbooks/edit/edit-reception-download-logbook/edit-reception-download-logbook.component';
import { EditProductLogbookComponent } from './logbooks/edit/edit-product-logbook/edit-product-logbook.component';
import { NoticesComponent } from './notices/notices.component';
import { AnnualProgramComponent } from '../annual-program/annual-program.component';
import { CreateLogbookManteinenceComponent} from '../annual-program/create-logbook-manteinence/create-logbook-manteinence.component';
import { ExternalStaffComponent } from '../../external-staff/external-staff.component';
import { ModuleExternalStaffComponent } from '../../external-staff/module-external-staff/module-external-staff.component';
import { CovidComponent } from './covid/covid.component';
import { ControlMessagesComponent } from './control-messages/control-messages.component';
import { StatsComponent } from './covid/stats/stats.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TestComponent } from './covid/test/test.component';
import { PositiveTestsComponent } from './covid/positive-tests/positive-tests.component';
import { DeliverySanitaryEquipmentComponent } from './covid/delivery-sanitary-equipment/delivery-sanitary-equipment.component';
import { CovidNotificationsComponent } from './covid/covid-notifications/covid-notifications.component';
import { CovidVideosComponent } from './covid/covid-videos/covid-videos.component';
import { ProtectionEquipmentComponent } from './covid/protection-equipment/protection-equipment.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NewStationComponent } from '../../new-station/new-station.component';
import { NewsComponent } from './news/news.component';
import { NomBullyingComponent } from './nom-bullying/nom-bullying.component';
import { PoliticsComponent } from './nom-bullying/politics/politics.component';
import { ResultsComponent } from './nom-bullying/results/results.component';
import { TakeActionComponent } from './nom-bullying/take-action/take-action.component';
import { BullyingTestComponent } from './nom-bullying/test/test.component';
import { PaymentComponent } from '../../payment/payment.component';
import { TutorialsComponent } from './tutorials/tutorials/tutorials.component';
import { LogbooksIndicatorsComponent } from './indicators/logbooks-indicators/logbooks-indicators.component';
import { CreatePaymentReferenceComponent } from '../../payment/create-payment-reference/create-payment-reference.component';
import { HistoryPaymentReferenceComponent } from '../../payment/history-payment-reference/history-payment-reference.component';
import { AddEditPreferenceAnnualProgramComponent } from '../annual-program/add-edit-preference-annual-program/add-edit-preference-annual-program.component';
import { BateryCheckLogbookComponent } from './logbooks/batery-check-logbook/batery-check-logbook.component';
import { EditBatteryCheckComponent } from './logbooks/batery-check-logbook/edit-battery-check/edit-battery-check.component';
import { EventNom005ScfiLogbookComponent } from './logbooks/event-nom005-scfi-logbook/event-nom005-scfi-logbook.component';
import { EditEventNom005ScfiLogbookComponent } from './logbooks/event-nom005-scfi-logbook/edit-event-nom005-scfi-logbook/edit-event-nom005-scfi-logbook.component';
import { StaffOutsideStationComponent } from '../../staff-outside-station/staff-outside-station.component';
import { StaffOutsideStationModuleComponent } from '../../staff-outside-station/staff-outside-station-module/staff-outside-station-module.component';
import { MunicipalLegalRequirementComponent } from './legal-requirements/municipal-legal-requirement/municipal-legal-requirement.component';
import { CustomEnabledRequirementComponent } from './legal-requirements/municipal-legal-requirement/custom-enabled-requirement/custom-enabled-requirement.component';
import { UpdateLegalRequirementComponent } from './legal-requirements/update-legal-requirement/update-legal-requirement.component';
import { FileManagerRequirementComponent } from './legal-requirements/file-manager-requirement/file-manager-requirement.component';
import { LogbooksAuthorizationModuleComponent} from '../../authorizations/logbooks-authorization-module/logbooks-authorization-module.component';
import { LogbooksAuthorizationComponentComponent } from '../../authorizations/logbooks-authorization-module/logbooks-authorization-component/logbooks-authorization-component.component';
import { ExtinguisherComponent } from './logbooks/extinguisher/extinguisher.component';
import { DangerousResiduesComponent } from './logbooks/dangerous-residues/dangerous-residues.component';
import { ContaminatedSitesComponent } from './logbooks/contaminated-sites/contaminated-sites.component';
import { EditExtinguisherComponent } from './logbooks/extinguisher/edit/edit.component';
import { EditContaminatedSitesComponent } from './logbooks/contaminated-sites/edit/edit.component';
import { EditDangerousResiduesComponent } from './logbooks/dangerous-residues/edit/edit.component';
import { ChartsModule } from 'ng2-charts';
import {GeneralChartStatsComponent} from '../../general-chart-stats/general-chart-stats.component';
import {TotalStatisticsComponent} from '../../total-statistics/total-statistics.component';
import { AirTightnessComponent } from './logbooks/air-tightness/air-tightness.component';
import { EditAirTightnessComponent } from './logbooks/air-tightness/edit/edit.component';
import { ScheduledCleaningsComponent } from './logbooks/scheduled-cleanings/scheduled-cleanings.component';
import { EditScheduledCleaningsComponent } from './logbooks/scheduled-cleanings/edit/edit.component';
import { InspectionsAndIncidentsComponent } from './logbooks/inspections-and-incidents/inspections-and-incidents.component';
import { EditInspectionsAndIncidentsComponent } from './logbooks/inspections-and-incidents/edit/edit.component';
import { ShowPreviewFilesComponent } from '../../utils/show-preview-files/show-preview-files.component';
import { DocumentBridgeComponent } from '../../procedures/document-bridge/document-bridge.component';
import { FileManagerComponent } from '../../procedures/file-manager/file-manager.component';
import { SelectMonthReportComponent } from '../annual-program/select-month-report/select-month-report.component';
import { AddEditEventAnnualProgramComponent } from '../annual-program/add-edit-event-annual-program/add-edit-event-annual-program.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import {ServicesComponent} from './services/services.component';
import {NotificationsComponent} from './notifications/notifications.component';
import { RouterModule } from '@angular/router';
import { StatisticsComponent } from './statistics/statistics.component';
import { AddDocumentComponent } from './legal-requirements/file-manager-requirement/add-document/add-document.component';
import { ActionsDefaultEvents } from '../annual-program/actions-default-events/actions-default-events.component';
import { AddEditEventCleaningAnnualProgramComponent } from '../annual-program/add-edit-event-cleaning-annual-program/add-edit-event-cleaning-annual-program.component';
import { CreateLogbookCleaningComponent } from '../annual-program/create-logbook-cleaning/create-logbook-cleaning.component';
import { AgreementsComponent } from './legal-requirements/agreements/agreements.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { ObjectivesComponent } from '../../implementation-sassisopa/formats/procedure-4/objectives/objectives.component';
import { ObjectivesDetailsComponent } from '../../implementation-sassisopa/formats/procedure-4/objectives/objectives-details/objectives-details.component';
import { EditObjectivesComponent } from '../../implementation-sassisopa/formats/procedure-4/objectives/edit-objectives/edit-objectives.component';
import { ResourcesRequestComponent } from '../../implementation-sassisopa/formats/procedure-5/resources-request/resources-request.component';
import { OrganizationChartComponent } from '../../implementation-sassisopa/formats/procedure-5/organization-chart/organization-chart.component';
import { TechnicalRepresentativeComponent } from '../../implementation-sassisopa/formats/procedure-5/technical-representative/technical-representative.component';
import { TechnicalRepresentativeDetailsComponent } from '../../implementation-sassisopa/formats/procedure-5/technical-representative/technical-representative-details/technical-representative-details.component';
import { ResourcesRequestDetailsComponent } from '../../implementation-sassisopa/formats/procedure-5/resources-request/resources-request-details/resources-request-details.component';
import { TrainingNeedsComponent } from '../../implementation-sassisopa/formats/procedure-6/training-needs/training-needs.component';
import { TrainingProgramComponent } from '../../implementation-sassisopa/formats/procedure-6/training-program/training-program.component';
import { TrainingNeedsDetailsComponent } from '../../implementation-sassisopa/formats/procedure-6/training-needs/training-needs-details/training-needs-details.component';
import { JobProfileComponent } from '../../implementation-sassisopa/formats/procedure-6/job-profile/job-profile.component';
import { TrainingProgramDetailsComponent } from '../../implementation-sassisopa/formats/procedure-6/training-program/training-program-details/training-program-details.component';
import { JobProfileDetailsComponent } from '../../implementation-sassisopa/formats/procedure-6/job-profile/job-profile-details/job-profile-details.component';
import { CompetenciesComponent } from '../../implementation-sassisopa/formats/procedure-6/competencies/competencies.component';
import { CompetenciesDetailsComponent } from '../../implementation-sassisopa/formats/procedure-6/competencies/competencies-details/competencies-details.component';
import { TrainingEvaluationComponent } from '../../implementation-sassisopa/formats/procedure-6/training-evaluation/training-evaluation.component';
import { CommunicationControlComponent } from '../../implementation-sassisopa/formats/procedure-7/communication-control/communication-control.component';
import { CommunicationControlDetailsComponent } from '../../implementation-sassisopa/formats/procedure-7/communication-control/communication-control-details/communication-control-details.component';
import { UnsafeConditionsComponent } from '../../implementation-sassisopa/formats/procedure-7/unsafe-conditions/unsafe-conditions.component';
import { UnsafeConditionsDetailsComponent } from '../../implementation-sassisopa/formats/procedure-7/unsafe-conditions/unsafe-conditions-details/unsafe-conditions-details.component';
import { RequiredListComponent } from '../../implementation-sassisopa/formats/procedure-7/required-list/required-list.component';
import { RequiredListDetailsComponent } from '../../implementation-sassisopa/formats/procedure-7/required-list/required-list-details/required-list-details.component';
import { ReportsComponent } from '../../implementation-sassisopa/formats/procedure-7/reports/reports.component';
import { AssistanceCommunicationComponent } from '../../implementation-sassisopa/formats/procedure-7/assistance-communication/assistance-communication.component';
import { AssistanceCommunicationDetailsComponent } from '../../implementation-sassisopa/formats/procedure-7/assistance-communication/assistance-communication-details/assistance-communication-details.component';
import { ReportsDetailsComponent } from '../../implementation-sassisopa/formats/procedure-7/reports/reports-details/reports-details.component';
import { FollowUpServiceComponent } from '../../implementation-sassisopa/formats/procedure-8/follow-up-service/follow-up-service.component';
import { FollowUpServiceDetailsComponent } from '../../implementation-sassisopa/formats/procedure-8/follow-up-service/follow-up-service-details/follow-up-service-details.component';
import { ActionsManagerComponent } from '../../implementation-sassisopa/actions-manager/actions-manager.component';
import { FormatManagerComponent } from '../../implementation-sassisopa/format-manager/format-manager.component';
import { ConfidentialityAgreementComponent } from '../../implementation-sassisopa/formats/procedure-8/confidentiality-agreement/confidentiality-agreement.component';
import { ConfidentialityAgreementDetailsComponent } from '../../implementation-sassisopa/formats/procedure-8/confidentiality-agreement/confidentiality-agreement-details/confidentiality-agreement-details.component';
import { BestPracticesComponent } from '../../implementation-sassisopa/formats/procedure-9/best-practices/best-practices.component';
import { BestPracticesDetailsComponent } from '../../implementation-sassisopa/formats/procedure-9/best-practices/best-practices-details/best-practices-details.component';
import { OperationControlsComponent } from '../../implementation-sassisopa/formats/procedure-10/operation-controls/operation-controls.component';
import { OperationControlsDetailsComponent } from '../../implementation-sassisopa/formats/procedure-10/operation-controls/operation-controls-details/operation-controls-details.component';
import { ContractorComponent } from '../../implementation-sassisopa/formats/procedure-12/contractor/contractor.component';
import { ContractorDetailsComponent } from '../../implementation-sassisopa/formats/procedure-12/contractor/contractor-details/contractor-details.component';
import { ResponsiveLetterComponent } from '../../implementation-sassisopa/formats/procedure-12/responsive-letter/responsive-letter.component';
import { ResponsiveLetterDetailsComponent } from '../../implementation-sassisopa/formats/procedure-12/responsive-letter/responsive-letter-details/responsive-letter-details.component';
import { SupplierDetailsComponent } from '../../implementation-sassisopa/formats/procedure-12/supplier/supplier-details/supplier-details.component';
import { PoliticsIndexComponent } from '../../implementation-sassisopa/formats/procedure-1/politics/index/politics-index.component';
import { PoliticsEditComponent } from '../../implementation-sassisopa/formats/procedure-1/politics/edit/politics-edit.component';
import { PoliticsCreateComponent} from '../../implementation-sassisopa/formats/procedure-1/politics/create/politics-create.component';
import {EmergencyPlanningComponent} from '../../implementation-sassisopa/formats/procedure-13/emergency-planning/emergency-planning.component';
import {
  EmergencyPlanningFormComponent,
} from '../../implementation-sassisopa/formats/procedure-13/emergency-planning/emergency-planning-form/emergency-planning-form.component';
import {
  EmergencyContactsComponent,
} from '../../implementation-sassisopa/formats/procedure-13/emergency-contacts/emergency-contacts.component';
import {
  EmergencyContactsFormComponent,
} from '../../implementation-sassisopa/formats/procedure-13/emergency-contacts/emergency-contacts-form/emergency-contacts-form.component';
import {BrigadesComponent} from '../../implementation-sassisopa/formats/procedure-13/brigades/brigades.component';
import {
  BrigadesFormComponent,
} from '../../implementation-sassisopa/formats/procedure-13/brigades/brigades-form/brigades-form.component';
import {
  ResourceAvailabilityComponent,
} from '../../implementation-sassisopa/formats/procedure-13/resource-availability/resource-availability.component';
import {
  ResourceAvailabilityFormComponent,
} from '../../implementation-sassisopa/formats/procedure-13/resource-availability/resource-availability-form/resource-availability-form.component';
import { ValidateOpenDetailComponent } from '../../implementation-sassisopa/documents/validate-open-detail/validate-open-detail.component';
import { ResultsReportComponent } from '../../implementation-sassisopa/formats/procedure-17/results-report/results-report.component';
import { ResultsReportFormComponent } from '../../implementation-sassisopa/formats/procedure-17/results-report/results-report-form/results-report-form.component';
import { FindingsManagerComponent} from '../../implementation-sassisopa/formats/procedure-14/findings-manager/findings-manager.component';
import { FindingsManagerFormComponent } from '../../implementation-sassisopa/formats/procedure-14/findings-manager/findings-manager-form/findings-manager-form.component';
import {
  CriticalEquipmentComponent,
} from '../../implementation-sassisopa/formats/procedure-11/critical-equipment/critical-equipment.component';
import {
  CriticalEquipmentFormComponent,
} from '../../implementation-sassisopa/formats/procedure-11/critical-equipment-form/critical-equipment-form.component';
import {
  ChangesControlComponent,
} from '../../implementation-sassisopa/formats/procedure-11/changes-control/changes-control.component';
import {
  ChangesControlFormComponent,
} from '../../implementation-sassisopa/formats/procedure-11/changes-control-form/changes-control-form.component';
import { InvestigationActivitiesProgramComponent } from '../../implementation-sassisopa/formats/procedure-16/investigation-activities-program/investigation-activities-program.component';
import { InvestigationActivitiesProgramFormComponent } from '../../implementation-sassisopa/formats/procedure-16/investigation-activities-program/investigation-activities-program-form/investigation-activities-program-form.component';
import { ReviewResultsComponent } from '../../implementation-sassisopa/formats/procedure-17/review-results/review-results.component';
import { ReviewResultsFormComponent } from '../../implementation-sassisopa/formats/procedure-17/review-results/review-results-form/review-results-form.component';
import { AuditProgramComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-program/audit-program.component';
import { AuditProgramFormComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-program/audit-program-form/audit-program-form.component';
import { AuditReportComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-report/audit-report.component';
import { AuditReportFormComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-report/audit-report-form/audit-report-form.component';
import { AuditPlanComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-plan/audit-plan.component';
import { AuditPlanFormComponent } from '../../implementation-sassisopa/formats/procedure-15/audit-plan/audit-plan-form/audit-plan-form.component';
import { OpenOptionSasisopaComponent } from '../../implementation-sassisopa/open-option-sasisopa.component';
import { ValidateOpenOptionComponent } from './sgm/validate-open-option/validate-open-option.component';
import { AnexoCuatroComponent } from './sgm/anexo-cuatro/anexo-cuatro.component';
import { AnexoSeisComponent } from './sgm/anexo-seis/anexo-seis.component';
import { FormatoUnoComponent } from './sgm/formato-uno/formato-uno.component';
import { FormatoTresComponent } from './sgm/formato-tres/formato-tres.component';
import { FormatoCincoComponent } from './sgm/formato-cinco/formato-cinco.component';
import { FormatoSeisComponent } from './sgm/formato-seis/formato-seis.component';
import { FormatoNueveComponent } from './sgm/formato-nueve/formato-nueve.component';
import { FormatoOnceComponent } from './sgm/formato-once/formato-once.component';
import { FormatoTreceComponent } from './sgm/formato-trece/formato-trece.component';
import { FormatoQuinceComponent } from './sgm/formato-quince/formato-quince.component';
import { FormatoCatorceComponent } from './sgm/formato-catorce/formato-catorce.component';
import { FormatoDiezysieteComponent } from './sgm/formato-diezysiete/formato-diezysiete.component';
import { FormatoDiezyochoComponent } from './sgm/formato-diezyocho/formato-diezyocho.component';
import { FormatoDiezynueveComponent } from './sgm/formato-diezynueve/formato-diezynueve.component';
import { UsersSgmSasisopaComponent } from './sgm/users-sgm-sasisopa/users-sgm-sasisopa.component';
import { UsersSgmSasisopaFormComponent } from './sgm/users-sgm-sasisopa-form/users-sgm-sasisopa-form.component';
import { FormatoVeinteComponent } from './sgm/formato-veinte/formato-veinte.component';
import { FormatoVeinteDosComponent } from './sgm/formato-veinte-dos/formato-veinte-dos.component';
import { FormatoVeinteTresComponent } from './sgm/formato-veinte-tres/formato-veinte-tres.component';
import { FormatoDosComponent } from './sgm/formato-dos/formato-dos.component';
import { FormatoVeinteCuatroComponent } from './sgm/formato-veinte-cuatro/formato-veinte-cuatro.component';
import { FormatoVeinteCincoComponent } from './sgm/formato-veinte-cinco/formato-veinte-cinco.component';
import { FormatoVeinteSeisComponent } from './sgm/formato-veinte-seis/formato-veinte-seis.component';
import { FormatoSieteComponent } from './sgm/formato-siete/formato-siete.component';
import { FormatoDoceComponent } from './sgm/formato-doce/formato-doce.component';
import { FormatoCuatroComponent } from './sgm/formato-cuatro/formato-cuatro.component';
import { FormatoOchoComponent } from './sgm/formato-ocho/formato-ocho.component';
import { FormatoVeinteOchoComponent } from './sgm/formato-veinte-ocho/formato-veinte-ocho.component';
import { FormatoVeinteUnoComponent } from './sgm/formato-veinte-uno/formato-veinte-uno.component';
import { FormatoDiezSeisComponent } from './sgm/formato-diez-seis/formato-diez-seis.component';
import { FormatoTreintaUnoComponent } from './sgm/formato-treinta-uno/formato-treinta-uno.component';
import { FormatoTreintaComponent } from './sgm/formato-treinta/formato-treinta.component';
import { FormatoVeinteNueveComponent } from './sgm/formato-veinte-nueve/formato-veinte-nueve.component';
import { AnexoDiezComponent } from './sgm/anexo-diez/anexo-diez.component';
import { FormatoTreintaDosComponent } from './sgm/formato-treinta-dos/formato-treinta-dos.component';
import { FormatoDosUnoComponent } from './sassisopa/procedure-2/formato-dos-uno/formato-dos-uno.component';
import { FormatoTresUnoComponent } from './sassisopa/procedure-3/formato-tres-uno/formato-tres-uno.component';
import {SafeUrlPipe} from "../../@theme/pipes/safe-url.pipe";
import {ThemeModule} from "../../@theme/theme.module";
import { FormatoOchoUnoSassisopaComponent } from './sassisopa/procedure-8/formato-ocho-uno-sassisopa/formato-ocho-uno-sassisopa.component';
import { FormatoOchoDosSassisopaComponent } from './sassisopa/procedure-8/formato-ocho-dos-sassisopa/formato-ocho-dos-sassisopa.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: true,
};

registerLocaleData(localeEs);

@NgModule({
  imports: [
    RouterModule,
    ChartsModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    ChartModule,
    NbProgressBarModule,
    NgxEchartsModule,
    NgxChartsModule,
    LeafletModule,
    NbSpinnerModule,
    NbCalendarModule,
    NbCalendarRangeModule,
    NbSelectModule,
    FormsModule,
    NbDatepickerModule,
    NgxMaterialTimepickerModule,
    SignaturePadModule,
    ReactiveFormsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxMaterialTimepickerModule,
    NgxDaterangepickerMd.forRoot(),
    NbAlertModule,
    NbDialogModule.forRoot(),
    Ng2SmartTableModule,
    NgApexchartsModule,
    NbRouteTabsetModule,
    NbLayoutModule,
    NbAccordionModule,
    NbCheckboxModule,
    NbRadioModule,
    NbStepperModule,
    NbSecurityModule.forRoot({
      accessControl: {
        logbooksUser: {
          view: ['logbooks', 'anualProgram', 'news', 'tutorials'],
        },
        maintenanceUser: {
          parent: 'logbooksUser',
          view: ['legalRequirements', 'calendar', 'news', 'courses', 'nom-035'],
        },
        admin: {
          parent: 'maintenanceUser',
          view: ['sassisopa', 'sgm', 'implementation', 'employees', 'addStation', 'editStation', 'covid', 'anualProgram'],
        },
        superadmin: {
          parent: 'admin',
          view: ['editSignature', 'indicators', 'sysUsers'],
        },
      },
    }),
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    NbToastrModule.forRoot(),
    Ng2SearchPipeModule,
    NgbTypeaheadModule,
    NbBadgeModule,
    NbTooltipModule,
    NbInputModule,
    SwiperModule,
    MatNativeDateModule,
    MatTableModule,
    ThemeModule,
  ],
  declarations: [
    SplasboardComponent,
    StationsIndicatorsComponent,
    LegalRequirementsComponent,
    CustomRendererComponent,
    ActionsDefaultEvents,
    ValidateOpenDetailComponent,
    CalendarComponent,
    SassisopaComponent,
    SgmComponent,
    LogbooksSectionComponent,
    IndicatorsComponent,
    CapacitationComponent,
    AddincientLogbookComponent,
    AddManteinenceLogbookComponent,
    AddReceptionDownloadLogbookComponent,
    AddProductLogbookComponent,
    LogbooksComponent,
    SetDateLegalRequirementComponent,
    EmployeesComponent,
    NewEmployeeComponent,
    EditEmployeeComponent,
    AddLogbookComponent,
    ImplementationSassisopaComponent,
    DocumentsComponent,
    DocumentDetailSasisopa,
    DocumentDetailSasisopaEditCreateDeleteComponent,
    AddStationComponent,
    ProcedureOneComponent,
    ProcedureTwoComponent,
    ProcedureThreeComponent,
    ProcedureFourComponent,
    ProcedureFiveComponent,
    ProcedureSixComponent,
    ProcedureSevenComponent,
    ProcedureEigthComponent,
    ProcedureNineComponent,
    ProcedureTenComponent,
    ProcedureElevenComponent,
    ProcedureTwelveComponent,
    ProcedureThirteenComponent,
    ProcedureFourteenComponent,
    ProcedureFiveteenComponent,
    ProcedureSixteenComponent,
    ProcedureSeventeenComponent,
    ProcedureEigthteenComponent,
    UsersComponent,
    EditUserComponent,
    NewUserComponent,
    MeetingsComponent,
    AddMeetingComponent,
    EditMeetingComponent,
    MachinesComponent,
    NewMachineComponent,
    EditMachineComponent,
    SysUsersComponent,
    EditSysUsersComponent,
    NewSysUsersComponent,
    CompleteRegisterComponent,
    EditStationComponent,
    DetailStationComponent,
    ProfileComponent,
    EditLogbookComponent,
    EditIncientLogbookComponent,
    EditManteinenceLogbookComponent,
    EditReceptionDownloadLogbookComponent,
    EditProductLogbookComponent,
    NoticesComponent,
    AnnualProgramComponent,
    CreateLogbookManteinenceComponent,
    ExternalStaffComponent,
    ModuleExternalStaffComponent,
    CovidComponent,
    ControlMessagesComponent,
    StatsComponent,
    TestComponent,
    PositiveTestsComponent,
    DeliverySanitaryEquipmentComponent,
    CovidNotificationsComponent,
    CovidVideosComponent,
    ProtectionEquipmentComponent,
    NewStationComponent,
    NewsComponent,
    ServicesComponent,
    NotificationsComponent,
    NomBullyingComponent,
    PoliticsComponent,
    ResultsComponent,
    TakeActionComponent,
    BullyingTestComponent,
    PaymentComponent,
    TutorialsComponent,
    LogbooksIndicatorsComponent,
    CreatePaymentReferenceComponent,
    HistoryPaymentReferenceComponent,
    AddEditPreferenceAnnualProgramComponent,
    BateryCheckLogbookComponent,
    EditBatteryCheckComponent,
    EventNom005ScfiLogbookComponent,
    EditEventNom005ScfiLogbookComponent,
    MunicipalLegalRequirementComponent,
    CustomEnabledRequirementComponent,
    StaffOutsideStationModuleComponent,
    StaffOutsideStationComponent,
    UpdateLegalRequirementComponent,
    FileManagerRequirementComponent,
    FileManagerComponentSasisopa,
    LogbooksAuthorizationModuleComponent,
    LogbooksAuthorizationComponentComponent,
    ExtinguisherComponent,
    DangerousResiduesComponent,
    ContaminatedSitesComponent,
    EditExtinguisherComponent,
    EditDangerousResiduesComponent,
    EditContaminatedSitesComponent,
    GeneralChartStatsComponent,
    TotalStatisticsComponent,
    AirTightnessComponent,
    EditAirTightnessComponent,
    ScheduledCleaningsComponent,
    EditScheduledCleaningsComponent,
    InspectionsAndIncidentsComponent,
    EditInspectionsAndIncidentsComponent,
    ShowPreviewFilesComponent,
    DocumentBridgeComponent,
    FileManagerComponent,
    AddEditEventAnnualProgramComponent,
    AddEditEventCleaningAnnualProgramComponent,
    SelectMonthReportComponent,
    StatisticsComponent,
    AddDocumentComponent,
    CreateLogbookCleaningComponent,
    AgreementsComponent,
    ObjectivesComponent,
    PoliticsIndexComponent,
    PoliticsEditComponent,
    PoliticsCreateComponent,
    ObjectivesDetailsComponent,
    EditObjectivesComponent,
    ResourcesRequestComponent,
    OrganizationChartComponent,
    TechnicalRepresentativeComponent,
    TechnicalRepresentativeDetailsComponent,
    ResourcesRequestDetailsComponent,
    TrainingNeedsComponent,
    TrainingProgramComponent,
    TrainingNeedsDetailsComponent,
    JobProfileComponent,
    TrainingProgramDetailsComponent,
    JobProfileDetailsComponent,
    CompetenciesComponent,
    CompetenciesDetailsComponent,
    TrainingEvaluationComponent,
    CommunicationControlComponent,
    CommunicationControlDetailsComponent,
    UnsafeConditionsComponent,
    UnsafeConditionsDetailsComponent,
    RequiredListComponent,
    RequiredListDetailsComponent,
    ReportsComponent,
    ReportsDetailsComponent,
    AssistanceCommunicationComponent,
    AssistanceCommunicationDetailsComponent,
    FollowUpServiceComponent,
    FollowUpServiceDetailsComponent,
    ActionsManagerComponent,
    FormatManagerComponent,
    ConfidentialityAgreementComponent,
    ConfidentialityAgreementDetailsComponent,
    BestPracticesComponent,
    BestPracticesDetailsComponent,
    OperationControlsComponent,
    OperationControlsDetailsComponent,
    ContractorComponent,
    ContractorDetailsComponent,
    ResponsiveLetterComponent,
    ResponsiveLetterDetailsComponent,
    SupplierDetailsComponent,
    EmergencyPlanningComponent,
    EmergencyPlanningFormComponent,
    EmergencyContactsComponent,
    EmergencyContactsFormComponent,
    BrigadesComponent,
    BrigadesFormComponent,
    ResourceAvailabilityComponent,
    ResourceAvailabilityFormComponent,
    ResultsReportComponent,
    ResultsReportFormComponent,
    FindingsManagerComponent,
    FindingsManagerFormComponent,
    CriticalEquipmentComponent,
    CriticalEquipmentFormComponent,
    ChangesControlComponent,
    ChangesControlFormComponent,
    InvestigationActivitiesProgramComponent,
    InvestigationActivitiesProgramFormComponent,
    ReviewResultsComponent,
    ReviewResultsFormComponent,
    AuditProgramComponent,
    AuditProgramFormComponent,
    AuditReportComponent,
    AuditReportFormComponent,
    AuditPlanComponent,
    AuditPlanFormComponent,
    ValidateOpenOptionComponent,
    OpenOptionSasisopaComponent,
    AnexoCuatroComponent,
    AnexoSeisComponent,
    FormatoUnoComponent,
    FormatoTresComponent,
    FormatoCincoComponent,
    FormatoSeisComponent,
    FormatoNueveComponent,
    FormatoOnceComponent,
    FormatoTreceComponent,
    FormatoQuinceComponent,
    FormatoCatorceComponent,
    FormatoDiezysieteComponent,
    FormatoDiezyochoComponent,
    FormatoDiezynueveComponent,
    UsersSgmSasisopaComponent,
    UsersSgmSasisopaFormComponent,
    FormatoVeinteComponent,
    FormatoVeinteDosComponent,
    FormatoVeinteTresComponent,
    FormatoDosComponent,
    FormatoVeinteCuatroComponent,
    FormatoVeinteCincoComponent,
    FormatoVeinteSeisComponent,
    FormatoSieteComponent,
    FormatoDoceComponent,
    FormatoCuatroComponent,
    FormatoOchoComponent,
    FormatoVeinteOchoComponent,
    FormatoVeinteUnoComponent,
    FormatoDiezSeisComponent,
    FormatoTreintaUnoComponent,
    FormatoTreintaComponent,
    FormatoVeinteNueveComponent,
    AnexoDiezComponent,
    FormatoTreintaDosComponent,
    FormatoDosUnoComponent,
    FormatoTresUnoComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    FormatoOchoUnoSassisopaComponent,
    FormatoOchoDosSassisopaComponent,
  ],
  entryComponents: [
    SetDateLegalRequirementComponent,
    NewEmployeeComponent,
    EditEmployeeComponent,
    AddLogbookComponent,
    AddStationComponent,
    EditStationComponent,
    DetailStationComponent,
    NewUserComponent,
    EditUserComponent,
    AddMeetingComponent,
    EditMeetingComponent,
    NewMachineComponent,
    EditMachineComponent,
    EditSysUsersComponent,
    NewSysUsersComponent,
    EditLogbookComponent,
    CustomRendererComponent,
    ActionsDefaultEvents,
    ValidateOpenDetailComponent,
    ValidateOpenOptionComponent,
    OpenOptionSasisopaComponent,
    CreateLogbookManteinenceComponent,
    ModuleExternalStaffComponent,
    CreatePaymentReferenceComponent,
    HistoryPaymentReferenceComponent,
    AddEditPreferenceAnnualProgramComponent,
    MunicipalLegalRequirementComponent,
    CustomEnabledRequirementComponent,
    StaffOutsideStationModuleComponent,
    StaffOutsideStationComponent,
    UpdateLegalRequirementComponent,
    FileManagerRequirementComponent,
    FileManagerComponentSasisopa,
    LogbooksAuthorizationComponentComponent,
    ExtinguisherComponent,
    EditExtinguisherComponent,
    DangerousResiduesComponent,
    ContaminatedSitesComponent,
    EditDangerousResiduesComponent,
    EditContaminatedSitesComponent,
    AirTightnessComponent,
    EditAirTightnessComponent,
    EditScheduledCleaningsComponent,
    EditInspectionsAndIncidentsComponent,
    ShowPreviewFilesComponent,
    FileManagerComponent,
    AddEditEventAnnualProgramComponent,
    AddEditEventCleaningAnnualProgramComponent,
    SelectMonthReportComponent,
    DocumentDetailSasisopaEditCreateDeleteComponent,
    AddDocumentComponent,
    CreateLogbookCleaningComponent,
    AgreementsComponent,
    ObjectivesComponent,
    PoliticsIndexComponent,
    PoliticsEditComponent,
    PoliticsCreateComponent,
    ObjectivesDetailsComponent,
    EditObjectivesComponent,
    ResourcesRequestComponent,
    OrganizationChartComponent,
    TechnicalRepresentativeComponent,
    TechnicalRepresentativeDetailsComponent,
    ResourcesRequestDetailsComponent,
    TrainingNeedsComponent,
    TrainingProgramComponent,
    TrainingNeedsDetailsComponent,
    JobProfileComponent,
    TrainingProgramDetailsComponent,
    JobProfileDetailsComponent,
    CompetenciesComponent,
    CompetenciesDetailsComponent,
    TrainingEvaluationComponent,
    CommunicationControlComponent,
    CommunicationControlDetailsComponent,
    UnsafeConditionsComponent,
    UnsafeConditionsDetailsComponent,
    RequiredListComponent,
    RequiredListDetailsComponent,
    ReportsComponent,
    ReportsDetailsComponent,
    AssistanceCommunicationComponent,
    AssistanceCommunicationDetailsComponent,
    FollowUpServiceComponent,
    FollowUpServiceDetailsComponent,
    ActionsManagerComponent,
    FormatManagerComponent,
    ConfidentialityAgreementComponent,
    ConfidentialityAgreementDetailsComponent,
    BestPracticesComponent,
    BestPracticesDetailsComponent,
    OperationControlsComponent,
    OperationControlsDetailsComponent,
    ContractorComponent,
    ContractorDetailsComponent,
    ResponsiveLetterComponent,
    ResponsiveLetterDetailsComponent,
    SupplierDetailsComponent,
    EmergencyPlanningComponent,
    EmergencyPlanningFormComponent,
    EmergencyContactsComponent,
    EmergencyContactsFormComponent,
    BrigadesComponent,
    BrigadesFormComponent,
    ResourceAvailabilityComponent,
    ResourceAvailabilityFormComponent,
    ResultsReportComponent,
    ResultsReportFormComponent,
    FindingsManagerComponent,
    FindingsManagerFormComponent,
    CriticalEquipmentComponent,
    CriticalEquipmentFormComponent,
    ChangesControlComponent,
    ChangesControlFormComponent,
    InvestigationActivitiesProgramComponent,
    InvestigationActivitiesProgramFormComponent,
    ReviewResultsComponent,
    ReviewResultsFormComponent,
    AuditProgramComponent,
    AuditProgramFormComponent,
    AuditReportComponent,
    AuditReportFormComponent,
    AuditPlanComponent,
    AuditPlanFormComponent,
    AnexoCuatroComponent,
    FormatoUnoComponent,
    UsersSgmSasisopaComponent,
    UsersSgmSasisopaFormComponent
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class SplashboardModule { }
